import { CatToggle } from '@blocks-react/components/Toggle';
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';

interface DealerLocatorMapToggleProps {
  label: string;
  isChecked: boolean;
  setIsChecked: () => void;
  isDisabled?: boolean;
}

export const DealerLocatorMapToggle = ({
  label,
  isChecked,
  setIsChecked,
  isDisabled
}: DealerLocatorMapToggleProps) => {
  return (
    <div className="d-flex align-items-center">
      <CatToggle
        checked={isChecked}
        label={label}
        hideLabel
        onBlToggleChange={setIsChecked}
        disabled={isDisabled}
      />
      <p
        className={cx(
          styles['dealer-locator-text'],
          'cat-u-theme-typography-label ps-2 mb-0'
        )}
      >
        {label}
      </p>
    </div>
  );
};
